import { Grid } from "@material-ui/core";
import { Box, Link } from "@mui/material";
import { FaFileInvoiceDollar, FaYoutube } from "react-icons/fa";
import { useMemo, useState } from "react";
import { Condominio } from "modules/groupPay/configuracaoGroupPay/ModalReplicarAcesso";
import TabelaConfigurarCondominios from "./TabelaConfigurarCondominios";
import { useStyles as useStylesConfiguracao } from "./configurarBuscaNFEmail/styles/ConfigurarBuscaNFEmailStyles";
import ModalConfiguracaoBuscaExterna from "./ModalConfiguracaoBuscaExterna";
import CustomSwitch from "shared/components/Switch/CustomSwitch";
import { useStyles as useStylesBuscaDesabilitada } from "../../groupPay/configuracaoGroupPay/configurarBuscaNFEmail/styles/BuscaDesabilitadaStyles";
import StandardModalBuscaExternaNf from "shared/components/standardModal/StandardModalBuscaExternaNf";

type BuscaExternaNfProps = {
  condominios: { content: Condominio[] };
  searchCondominio: string;
  setSearchCondominio: React.Dispatch<React.SetStateAction<string>>;
  onConfiguracaoSalva?: (condominioId: number) => void;
  onToggleBuscaExterna?: (ativo: boolean) => void;
};

const BuscaExternaNf: React.FC<BuscaExternaNfProps> = ({
  condominios,
  searchCondominio,
  setSearchCondominio,
  onConfiguracaoSalva,
  onToggleBuscaExterna,
}) => {
  const classes = useStylesConfiguracao();
  const classesBuscaDesabilitada = useStylesBuscaDesabilitada();

  const [showModalConfiguracaoBuscaExterna, setShowModalConfiguracaoBuscaExterna] = useState<boolean>(false);
  const [condominioSelecionado, setCondominioSelecionado] = useState<Condominio | null>(null);
  const [isBuscaExternaAtiva, setIsBuscaExternaAtiva] = useState(true);
  const [showModalAjudaBuscaExterna, setShowModalAjudaBuscaExterna] = useState(false);
  const [sortString, setSortString] = useState("nomeFantasia,ASC");

  const condominiosAtivosOrdenados = useMemo(() => {
    const listaFiltrada = condominios?.content?.filter(
      (condominio) => condominio.possuiGroupPayAtivo === true
    ) ?? [];

    switch (sortString) {
      case 'nomeFantasia,ASC':
        return [...listaFiltrada]?.sort((a, b) => a.nomeFantasia.localeCompare(b.nomeFantasia));
      case 'nomeFantasia,DESC':
        return [...listaFiltrada]?.sort((a, b) => b.nomeFantasia.localeCompare(a.nomeFantasia));
      case 'cnpj,ASC':
        return [...listaFiltrada]?.sort((a, b) => a.cnpj.localeCompare(b.cnpj));
      case 'cnpj,DESC':
        return [...listaFiltrada]?.sort((a, b) => b.cnpj.localeCompare(a.cnpj));
      default:
        return listaFiltrada;
    }
  }, [condominios, sortString]);

  const handleAbrirModal = (condominio: Condominio) => {
    setCondominioSelecionado(condominio);
    setShowModalConfiguracaoBuscaExterna(true);
  };

  const handleFecharModal = () => {
    setShowModalConfiguracaoBuscaExterna(false);
    setCondominioSelecionado(null);
  };

  const handleToggleChange = (_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    setIsBuscaExternaAtiva(checked);
    onToggleBuscaExterna?.(checked);
  };
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} style={{ marginLeft: "5rem" }}>
          <Box className={classes.header}>
            <Box className={classes.titleContainer}>
              <Box className={classes.titleWrapper}>
                <h2 className={classes.wizardTitle}>2. Configuração de busca de NF externa</h2>
                <span className={classes.headerPipe}>|</span>
                <Box className={classes.headerLinkContainer}>
                  <Link onClick={() => setShowModalAjudaBuscaExterna(true)} className={classes.headerLink}>
                    <FaYoutube size={18} />
                    Ver sobre a busca externa
                  </Link>
                  <div className={classes.toggleContainer}>
                    <CustomSwitch
                      usarValidacaoParaFormulario={false}
                      checked={isBuscaExternaAtiva}
                      onChange={handleToggleChange}
                    />
                    <span style={{ marginLeft: "0.3rem" }}>
                      {isBuscaExternaAtiva
                        ? "Quero usar a busca de NF externa"
                        : "Não quero usar a busca de NF externa"}
                    </span>
                  </div>
                </Box>
              </Box>
              <p className={classes.subtitle}>
                <p>Configure abaixo a busca automática de notas fiscais externas.</p>
                <p>
                  É necessário <strong> configurar individualmente cada condomínio ativo</strong> no Group Pay.
                </p>
              </p>
            </Box>
          </Box>
        </Grid>

        {isBuscaExternaAtiva && (
          <Grid item xs={12}>
            <TabelaConfigurarCondominios
              condominios={condominiosAtivosOrdenados}
              searchCondominio={searchCondominio}
              setSearchCondominio={setSearchCondominio}
              sizeInputSearch={5}
              renderCheckbox={false}
              openModal={handleAbrirModal}
              centerTable={true}
              tableSize={10}
              renderGrupoCondominios={false}
              setSortString={setSortString}
              isWizard
            />
          </Grid>
        )}

        {!isBuscaExternaAtiva && (
          <Grid item xs={12}>
            <Box
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "200px",
                textAlign: "center",
                padding: "2rem",
              }}
            >
              <Box className={classesBuscaDesabilitada.root}>
                <Box className={classesBuscaDesabilitada.iconContainer}>
                  <FaFileInvoiceDollar className={classesBuscaDesabilitada.icon} />
                </Box>

                <Box>
                  <h3 className={classesBuscaDesabilitada.title}>Consulta de notas fiscais desabilitada</h3>
                  <p className={classesBuscaDesabilitada.subtitle}>
                    A consulta de notas fiscais externas está desabilitada. Para usar essa opção, habilite acima e
                    configure os condomínios com os dados de acesso necessários.
                  </p>
                </Box>
              </Box>
            </Box>
          </Grid>
        )}
      </Grid>

      {condominioSelecionado && (
        <ModalConfiguracaoBuscaExterna
          showModal={showModalConfiguracaoBuscaExterna}
          closeModal={handleFecharModal}
          condominioId={condominioSelecionado.condominioId}
          condominio={condominioSelecionado}
          onConfiguracaoSalva={onConfiguracaoSalva}
          setShowModalConfiguracaoBuscaExterna={setShowModalConfiguracaoBuscaExterna}
        />
      )}
      <StandardModalBuscaExternaNf
        showModal={showModalAjudaBuscaExterna}
        onCloseModal={() => setShowModalAjudaBuscaExterna(false)}
      />
    </>
  );
};

export default BuscaExternaNf;